import {createAction} from '@reduxjs/toolkit';
import {CreatePubEditorDTO} from 'typescript/dto/createPubEditorDTO';
import UpdateUserDTO from 'typescript/dto/userDto';
import {withPayloadType} from 'typescript/types/PayloadType';

import {singlePageEditorNamespace} from './singlePageEditorSlice';

const getSingleEditorACS = createAction(`${singlePageEditorNamespace}/getSingleEditorACS`, withPayloadType<string>());

const updateEditorACS = createAction(
  `${singlePageEditorNamespace}/updateEditorACS`,
  withPayloadType<{id: string; data: UpdateUserDTO}>(),
);

const unassignPubACS = createAction(
  `${singlePageEditorNamespace}/unassignPub`,
  withPayloadType<{pubId: string; editorId: string; assignedPubId: string}>(),
);

const assignPubACS = createAction(`${singlePageEditorNamespace}/assignPub`, withPayloadType<CreatePubEditorDTO>());

const deleteEditorACS = createAction(`${singlePageEditorNamespace}/deleteEditorACS`, withPayloadType<string>());

export {getSingleEditorACS, updateEditorACS, unassignPubACS, assignPubACS, deleteEditorACS};
